import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

export async function refreshApproveOrderItem({ orderId, itemQuantityId }) {
  const response = await axios.get(`/RefreshApproveOrderItem?orderId=${orderId}&itemQuantityId=${itemQuantityId}`);
  return response;
}

export async function cartCheckApiFromArrayOfObj({ carts, facilityId }) {
  if (!carts || !Array.isArray(carts)) {
    console.error('carts is not a valid array');
    return Promise.reject(new Error('Invalid carts array'));
  }

  const items = carts.map((cart) => ({
    id: cart.id,
    vendorId: cart.vendorId,
    quantity: cart.quantity,
    price: cart.price,
    vendorItemId: cart?.sku || cart.vendorItemId,
    uomType: cart.uomType,
    isPPD: cart.isPPD,
    isPunchoutItem: cart.itemId === -1
  }));

  const formData = objectToFormData({ items, facilityId });
  const response = await axios.post('/CartCheck', formData);
  return response;
}

export async function cartCheckApiForOneItem(facilityId, itemArray) {
  const items = itemArray.map((itm) => ({
    id: itm.id,
    vendorId: itm.vendorId,
    quantity: itm.quantity,
    price: itm.price,
    vendorItemId: itm?.sku || itm.vendorItemId,
    uomType: itm.uomType,
    isPPD: itm?.isPPD,
  }));

  const formData = objectToFormData({ items, facilityId });
  const response = await axios.post('/CartCheck', formData);
  return response;
}